import { render, staticRenderFns } from "./GTXBlood.vue?vue&type=template&id=d41b235a&"
import script from "./GTXBlood.vue?vue&type=script&lang=js&"
export * from "./GTXBlood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports